module.exports = new __parcel__URL__("clouds.cca28251.svg").toString();